import { NumberFormatterWithUnit } from 'components/shared/NumberFormatter/NumberFormatterWithUnit';
import { useSPIntl } from 'hooks/useIntl';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { FC, useMemo } from 'react';

import { Block } from '../shared/Blocks/Block';
import { VerticalFormGroup } from '../shared/VerticalFormGroup';
import { ConnectedClientSelector } from './ClientSelector.connect';
import type { ProductSummaryProps } from './QuoteRealtimeFormProductSummary.connect';
import { connectProductSummary } from './QuoteRealtimeFormProductSummary.connect';

const fieldIds: string[] = ['ISIN', 'FileCode', 'QuotationType', 'priceType', 'MaturityDate', 'Denomination', 'client'];

export const Component: FC<ProductSummaryProps> = ({
  tabId,
  isinCode,
  denomination,
  fileCode,
  maturityDate,
  currency,
  quotationType,
  priceType,
}) => {
  const { formatDisplayedDate, formatMessage } = useSPIntl();
  const isInternalUser = useIsInternalUser();
  const maturityDateText = useMemo(
    () =>
      maturityDate !== undefined
        ? formatDisplayedDate(maturityDate, {
            day: '2-digit',
          })
        : undefined,
    [formatDisplayedDate, maturityDate],
  );

  return (
    <Block label="form.ProductSummary" id="ProductSummary" fieldIds={fieldIds}>
      <form name="marketProductSummary" noValidate autoComplete="off">
        <div className="row">
          <VerticalFormGroup inputId="ISIN" label="secondaryMarket.productSummary.label.isin" className="col-6">
            {isinCode !== undefined && <input className="form-control" id="ISIN" readOnly value={isinCode} />}
          </VerticalFormGroup>
          <VerticalFormGroup inputId="FileCode" label="secondaryMarket.productSummary.label.fileCode" className="col-6">
            {fileCode !== undefined && <input className="form-control" id="FileCode" readOnly value={fileCode} />}
          </VerticalFormGroup>
        </div>
        <div className="row">
          <VerticalFormGroup
            inputId="QuotationType"
            label="secondaryMarket.productSummary.label.quotationType"
            className="col-6"
          >
            {quotationType !== undefined && (
              <input
                className="form-control"
                id="QuotationType"
                readOnly
                value={formatMessage({ id: `secondaryMarket.productSummary.quotationType.${quotationType}` })}
              />
            )}
          </VerticalFormGroup>
          <VerticalFormGroup
            inputId="priceType"
            label="secondaryMarket.productSummary.label.priceType"
            className="col-6"
          >
            {priceType !== undefined && <input className="form-control" id="priceType" readOnly value={priceType} />}
          </VerticalFormGroup>
        </div>
        <div className="row">
          <VerticalFormGroup
            inputId="MaturityDate"
            label="secondaryMarket.productSummary.label.maturityDate"
            className="col-6"
          >
            {maturityDate !== undefined && (
              <input className="form-control" id="MaturityDate" readOnly value={maturityDateText} />
            )}
          </VerticalFormGroup>
          <VerticalFormGroup
            inputId="Denomination"
            label="secondaryMarket.productSummary.label.denomination"
            className="col-6"
          >
            {currency !== undefined && denomination !== undefined && (
              <NumberFormatterWithUnit isReadOnly value={denomination} unit={currency} e2e="CashAmount" />
            )}
          </VerticalFormGroup>
        </div>
        {isInternalUser && (
          <VerticalFormGroup inputId="client" label="secondaryMarket.productSummary.label.client">
            <ConnectedClientSelector className="flex-grow-1 justify-content-start min-width-0" tabId={tabId} />
          </VerticalFormGroup>
        )}
      </form>
    </Block>
  );
};

Component.displayName = 'QuoteRealtimeFormProductSummary';

export const QuoteRealtimeFormProductSummary = connectProductSummary(Component);

QuoteRealtimeFormProductSummary.displayName = 'ConnectedQuoteRealtimeFormProductSummary';
